var Midttrafik2016 = Midttrafik2016 || {};

Midttrafik2016.wcagForms = new function() {
    var self = this;

    this.init = function() {
        setTimeout(function() {
            var getInputFields = document.querySelectorAll('.contourPage input[readonly]');       
            for (var index = 0; index < getInputFields.length; index++) {
                var eachItem = getInputFields[index];
                self.setDisabeldAndTabindex(eachItem);
            }
        }, 100);
    };

    this.setDisabeldAndTabindex = function(element) {
        element.setAttribute('tabindex', "-1");
        element.setAttribute('disabled', true);
        if(element.classList.contains("datepickerfield")) {
            element.setAttribute('tabindex', "0");
            element.removeAttribute('disabled');
        }
        if(element.classList.contains("form-bus-routes")) {
            element.removeAttribute('disabled');
        }
    }
};